import { render, staticRenderFns } from "./Farmerstx.vue?vue&type=template&id=a1bb876a&scoped=true&"
import script from "./Farmerstx.vue?vue&type=script&lang=js&"
export * from "./Farmerstx.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/channel.css?vue&type=style&index=0&id=a1bb876a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bb876a",
  null
  
)

export default component.exports